import * as client from './client';
import { StoreApiError, type StartPortalSessionInput } from './types';

interface UrlResponse {
  url: string;
}

/**
 * Creates a Stripe Customer Portal session via alchemie-commerce
 * `createPortalSession` and redirects the browser. User must have completed
 * a prior checkout (server refuses to open a portal without a customer on file).
 */
export async function startBillingPortalSession(input: StartPortalSessionInput): Promise<void> {
  const { url } = await client.fetchJson<UrlResponse>({
    method: 'POST',
    relativePath: '/createPortalSession',
    body: {
      productId: input.productId,
      returnUrl: input.returnUrl,
    },
    errorContext: 'Portal session',
  });

  if (!url) {
    throw new StoreApiError('invalid-response', 'Billing server did not return a portal URL.');
  }

  client.redirectTo(url);
}
